import React from 'react';

const AllMasterPage = () => {
  return <div></div>;
};

export default AllMasterPage;
